import React, { useEffect, useRef, useState } from 'react';
import { GoogleMapsOverlay } from '@deck.gl/google-maps';
import { HeatmapLayer } from '@deck.gl/aggregation-layers';

const mapId = 'google-map-script';

function HeatMap({ data, center }) {
    //console.log(data, center)
    const mapRef = useRef(null);
    const [map, setMap] = useState(null);
    const overlayRef = useRef(null);

    // Initialize the Google Map
    useEffect(() => {
        if (mapRef.current && !map) {
            const googleMap = new window.google.maps.Map(mapRef.current, {
                center: center,
                zoom: 10,
                mapId,
            });
            setMap(googleMap);
        }
    }, [map, center]);

    // Handle deck.gl overlay lifecycle and data updates
    useEffect(() => {
        if (!map || !data) return;

        // Create the deck.gl HeatmapLayer configuration
        const deckLayer = new HeatmapLayer({
            id: 'heatmap-layer',
            data: data,
            getPosition: (d) => d.coordinates, // Returns [lng, lat]
            getWeight: (d) => d.weight || 1,    // Dictates intensity
            radiusPixels: 40,                  // Radius of points in pixels
            intensity: 1,                      // Global intensity multiplier
            threshold: 0.05,                   // Filters out low intensity noise
        });

        // Initialize the overlay if it doesn't exist yet
        if (!overlayRef.current) {
            overlayRef.current = new GoogleMapsOverlay({
                layers: [deckLayer],
            });
            overlayRef.current.setMap(map);
        } else {
            // Efficiently update layers when data changes without re-initializing
            overlayRef.current.setProps({ layers: [deckLayer] });
        }

        // Cleanup overlay on component unmount
        return () => {
            if (overlayRef.current) {
                overlayRef.current.setMap(null);
                overlayRef.current = null;
            }
        };
    }, [map, data]);

    return <div ref={mapRef} style={{ width: '100%', height: '330px' }} />;
}

export default HeatMap
